module.exports = "aofl-list-option > ng-transclude {\n  display: inline;\n}\n"